
export default {
  name: 'InsurerPageSectionBanner',

  props: {
    data: {
      type: Object,
      default: () => ({
      }),
    },
    data2: {
      type: Object,
      default: () => ({
      }),
    },
    categoryInfo: {
      type: Object,
      default: () => ({
      }),
    },
  },

  data() {
    return {
      width: 0,
      buttonStyle: {
        normal: {
          backgroundColor: 'transparent',
          textColor: '#16B7A6',
          borderColor: '#16B7A6',
        },
        active: {
          backgroundColor: '#16B7A6',
          textColor: '#white',
          borderColor: '#16B7A6',

        }
      }
    }
  },

  computed: {

  },
  
  methods: {
    subcategory(slug) {
      const currentSlug = this.$route.params.cat;
      const cat = this.categoryInfo.CategoryDetail.filter((item=>item.CategoryName === slug));
      const catMapped = cat.map(item => ({
                icon: item?.IconType,
                isActive: item?.CategoryName === currentSlug,
                target: '_self',
                text: item?.CategoryDisplayName,
                slug: item?.CategoryName
                
            }))
      return catMapped[0]
      },
    prepareButtonData(isActive, slug) {
      const data = {}
      const cat = this.categoryInfo.CategoryDetail.filter((item=>item.CategoryName === slug));
      let title = slug;
      let icon = '';
      if(cat.length >0 )
      {
        title = cat[0].CategoryDisplayName;
        icon = cat[0].IconType;
      }
      if (isActive) {
        return Object.assign(data , {
          text: title, 
          icon, 
          buttonColor: this.buttonStyle.active.backgroundColor, 
          buttonBorderColor: this.buttonStyle.active.borderColor,
          textColor: this.buttonStyle.active.textColor,
          disabled: true,
        })
      } else {
        return Object.assign(data , {
          text: title, 
          icon, 
          buttonColor: this.buttonStyle.normal.backgroundColor, 
          buttonBorderColor: this.buttonStyle.normal.borderColor,
          textColor: this.buttonStyle.normal.textColor,
          link: '/insurer/' + this.$route.params.code + '/' + slug
        })
      }
    },

    isActive(slug,index) {
      if (this.$route?.params?.cat === slug) {
        return true
      }
      return false
    },
    
    classNames(slug,index) {
      const classes = []
      classes.push(slug)
      
      if (this.isActive(slug,index)) {
        classes.push('active')
      }
      if (this.isActive(slug,index)) {
        classes.push('active')
      }
      return classes
    },
  },
}
